import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/normalize.css';
import './css/index.css';

import Layout from './components/Layout';
import Index from './components/index';
import Login from './components/login';
import Contacto from './components/Contacto';
import Menu from './components/Menu';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
 
const router=createBrowserRouter([
  {
    path:'/',
    element: <Layout/>,
    children:[
      {
      path:'/',
      element:<Index/>
    },
    // {
    //   path:'/panel',
    //   element:<Login/>
    // } ,
    // {
    //   path:'/contacto',
    //   element:<Contacto/>
    // }, 
    // {
    //   path:'/menu',
    //   element:<Menu/>
    // }    
  ]  
  },
])
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <RouterProvider router={router}/>
  </React.StrictMode>
);


